import 'swiper/css'
import 'swiper/css/pagination'

import Container from 'components/UI/Landing/container'
import SectionTitle from 'components/UI/Landing/section-title'
import SubTitle from 'components/UI/Landing/subtitle'
import WithGradient from 'components/UI/Landing/with-gradient'
import { useTranslation } from 'react-i18next'

import StepsSwiper from './steps-swiper'

export default function StepsSection(): JSX.Element {
  const { t } = useTranslation('landing')

  return (
    <section className='pb-20 pt-[19px] lg:pt-[100px] relative overflow-hidden'>
      <Container className='relative'>
        <div className='mb-[32px]'>
          <SectionTitle title={t('steps-section.title')} className='mb-2' />
          <SubTitle title={t('steps-section.subtitle')} className='text-[20px] leading-[140%] font-medium' />
        </div>
      </Container>
      <StepsSwiper />
      <WithGradient className='rounded-full w-[250px] h-[500px] absolute top-1/2 left-1/2 -translate-y-1/3 -translate-x-1/2 -rotate-45 opacity-40 blur-[115px] ' />
    </section>
  )
}
